
webpack.register(
    'modules/embed-video/embed-video',
    function() {
        return import('modules/embed-video/embed-video');
    },
    true
);